module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/dinner-course-photo-1-2-e5ba477310dd4a2d29e0dd9e56d8c5d3.jpg";